import { PopoverImg } from '@vzmi/shp_shared_compo'
import { IconPopoverLabel } from '../ProposalForm/FormLabelTooltip/FormLabelTooltip'
import styles from './index.css'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'

const BSMIIconPopoverLabel = (props) => {
  const { children } = props
  return (
    <IconPopoverLabel
      popoverContent={(
        <>
          <PopoverImg
            url={`${CDN}/supplier/bsmi-sample.png`}
            width={457}
            height={223}
          />
          <div className={styles.bsmi}>
            若商品BSMI證號為標準檢驗局印製標籤:
            <br />
            請依照產品上的標識號碼輸入英文字與數字，不須輸入空白及任何符號。
            <br />
            例: (J)C1 1052790 請輸入 JC11052790。
          </div>
        </>
      )}
    >
      {children}
    </IconPopoverLabel>
  )
}

export default BSMIIconPopoverLabel
